.map {
    position: relative;
    width: 100%;
    background: var(--tempest-surface-2);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-lg);
    font-family: var(--tempest-font-sans);
    overflow: hidden;
}

.svg {
    display: block;
    width: 100%;
}

.loading {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: var(--tempest-text-muted);
    font-size: var(--tempest-text-sm);
}

.state {
    fill: var(--tempest-surface-3);
    stroke: var(--tempest-border-strong);
    stroke-width: 0.75;
    stroke-linejoin: round;
    transition:
        fill 0.12s ease,
        opacity 0.12s ease;
}

.state[role="button"] {
    cursor: pointer;
}

.state[role="button"]:hover {
    fill: var(--tempest-primary-soft);
}

.state[role="button"]:focus-visible {
    outline: none;
    stroke: var(--tempest-primary);
    stroke-width: 1.5;
}

.selected {
    fill: var(--tempest-primary);
    stroke: var(--tempest-primary-active);
    stroke-width: 1.25;
}

.selected:hover {
    fill: var(--tempest-primary-hover);
}

.label {
    fill: var(--tempest-text);
    font-size: 10px;
    font-weight: var(--tempest-weight-medium);
    pointer-events: none;
    user-select: none;
}

.tooltip {
    position: absolute;
    z-index: 2;
    transform: translate(12px, 12px);
    max-width: 240px;
    padding: var(--tempest-space-2) var(--tempest-space-3);
    background: var(--tempest-surface);
    color: var(--tempest-text);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-md);
    box-shadow: var(--tempest-shadow-md, 0 4px 12px rgb(0 0 0 / 0.12));
    font-size: var(--tempest-text-xs);
    line-height: var(--tempest-leading-snug);
    pointer-events: none;
    white-space: nowrap;
}

.tooltipTitle {
    font-weight: var(--tempest-weight-semibold);
    font-size: var(--tempest-text-sm);
}

.tooltipMeta {
    color: var(--tempest-text-muted);
}

.marker {
    stroke: var(--tempest-surface);
    stroke-width: 2;
}

.marker[role="button"] {
    cursor: pointer;
}

.marker[role="button"]:hover {
    stroke: var(--tempest-primary-active);
}

.marker[role="button"]:focus-visible {
    outline: none;
    stroke: var(--tempest-primary);
    stroke-width: 3;
}

.zoomReset {
    position: absolute;
    top: var(--tempest-space-2);
    right: var(--tempest-space-2);
    padding: var(--tempest-space-1) var(--tempest-space-2);
    font-family: var(--tempest-font-sans);
    font-size: var(--tempest-text-xs);
    color: var(--tempest-text);
    background: var(--tempest-surface);
    border: 1px solid var(--tempest-border);
    border-radius: var(--tempest-radius-sm);
    cursor: pointer;
}

.zoomReset:hover {
    background: var(--tempest-surface-2);
}
